import { atom } from 'recoil';

export const errorState = atom({
  key: 'lastError',
  default: null,
});
